import { render, staticRenderFns } from "./TestDataAuthModal.vue?vue&type=template&id=c3d3ac56&scoped=true&"
import script from "./TestDataAuthModal.vue?vue&type=script&lang=js&"
export * from "./TestDataAuthModal.vue?vue&type=script&lang=js&"
import style0 from "./TestDataAuthModal.vue?vue&type=style&index=0&id=c3d3ac56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d3ac56",
  null
  
)

export default component.exports